let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4piMa")).then(() => parcelRequire('ga6aL'));